/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_Step_ThreeInputs */

const en_cc_step_three = /** @type {(inputs: Cc_Step_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to KerjaBareng. Open the full Google Calendar event editor, then click the extension icon and Choose a meeting.`)
};

const id_cc_step_three = /** @type {(inputs: Cc_Step_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke KerjaBareng. Buka editor acara lengkap Google Calendar, lalu klik ikon ekstensi dan Pilih meeting.`)
};

/**
* | output |
* | --- |
* | "Sign in to KerjaBareng. Open the full Google Calendar event editor, then click the extension icon and Choose a meeting." |
*
* @param {Cc_Step_ThreeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_step_three = /** @type {((inputs?: Cc_Step_ThreeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Step_ThreeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_step_three(inputs)
	return en_cc_step_three(inputs)
});